import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import RecommendationAPI from '@/api/recommendation'
import UsersAPI from '@/api/users'

export default {
  state: {
    directions: null,
    professions: null,
    usersInterestedInProfessions: null,
    allUsersOlympadsResults: null
  },

  mutations: {
    [MUTATION_TYPE.setDirections]: (state, newDirections) => {
      state.directions = newDirections; 
    },
    [MUTATION_TYPE.setProfessions]: (state, newProfessions) => {
      state.professions = newProfessions;
    },
    [MUTATION_TYPE.setUsersInterestedInProfessions]: (state, newUsers) => {
      state.usersInterestedInProfessions = newUsers;
    },
    [MUTATION_TYPE.setAllUsersOlympiadsResults]: (state, newResults) => {
      state.allUsersOlympadsResults = newResults;
    }
  },

  actions: {
    [ACTION_TYPE.fetchDirections]: async ({ commit }) => {
      commit(MUTATION_TYPE.setDirections, (await RecommendationAPI.getDirectionsByUniversity()).data);
    },
    [ACTION_TYPE.fetchProfessions]: async ({commit}) => {
      commit(MUTATION_TYPE.setProfessions, (await RecommendationAPI.getProfessionsList()).data.professions);
    },
    [ACTION_TYPE.fetchUsersInterestedInProfessions]: async ({commit}) => {
      commit(MUTATION_TYPE.setUsersInterestedInProfessions, (await UsersAPI.getUsersInterestedInProfessions()).data);
    },
    [ACTION_TYPE.fetchAllUsersOlympiadsResults]: async ({commit}) => {
      commit(MUTATION_TYPE.setAllUsersOlympiadsResults, (await UsersAPI.getAllUsersOlympiadsResults()).data);
    }
  },
  getters: {
    [GETTER_TYPE.getProfession]: (state) => (id) => {
      return _.find(state.professions, ['id', id])
    },
    [GETTER_TYPE.getProfessionsList]: (state) => {
      return state.professions;
    },
    [GETTER_TYPE.getDirections]: (state) => {
      return state.directions;
    },
    [GETTER_TYPE.getUsersInterestedInProfessions]: (state) => {
      return state.usersInterestedInProfessions
    },
    [GETTER_TYPE.getAllUsersOlympiadsResults]: (state) => {
      return state.allUsersOlympadsResults;
    }
  }
}
